<template>
  <div class="gx-bb">
<!--    <h1 class="gx-main__title">资源盲盒</h1>-->
    <gx-loading :show="loading" />

    <div class="gx-bb__notice">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="flex-shrink: 0; margin-top: 1px;"><path d="M8 1.5l7 12H1L8 1.5z" stroke="#FB923C" stroke-width="1.3" stroke-linejoin="round"></path><path d="M8 6v4M8 12v.5" stroke="#FB923C" stroke-width="1.3" stroke-linecap="round"></path></svg>
      <p>
        <span style="color: rgb(251, 146, 60); font-weight: 600;">免责声明：</span>
        本站货盘将铺货到您店铺草稿箱，请您审核后再上架商品，上架后的商品出现任何违规，均与本站无关，使用本站即默认本条约!
      </p>
    </div>
    <div class="gx-bb__plat-tabs">
      <button
          v-for="p in platforms"
          :key="p.value"
          class="gx-bb__plat-tab"
          :class="{ 'gx-bb__plat-tab--on': searchData.shop_type === p.value }"
          @click="bindShopTypeChange(p.value)"
      >{{ p.label }}</button>
    </div>
    <div class="gx-bb__filter custom-form-wrap">
      <el-form inline size="mini">
        <el-form-item label="店铺分组：">
          <el-select v-model="searchData.group_ids" placeholder="全部分组" clearable
                     multiple collapse-tags filterable @change="setChange">
            <el-option v-for="item in groupList" :key="item.id" :label="item.name"
                       :value="item.id" />
            <el-option v-if="is_host" label="未分组" value="-1">未分组</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺名称：">
          <el-select v-model="searchData.shop_name" filterable placeholder="请选择" clearable >
            <el-option v-for="item in shopList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="盲盒状态：">
          <el-select v-model="searchData.daily_status" placeholder="全部" clearable class="w120">
            <el-option label="开启中" value="2"></el-option>
            <el-option label="已暂停" value="1"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="searchData.shop_type===7">
          <div class="gx-bb__spacer"></div>
          <button type="button" class="gx-bb__btn gx-bb__btn--danger" @click="handleSearch">查询</button>
          <button type="button" class="gx-bb__btn" @click="handleReset">重置</button>
        </template>
      </el-form>
      <template v-if="searchData.shop_type===1">
        <el-form inline size="mini">
          <el-form-item label="低动销店铺：" >
            <el-select v-model="searchData.low_sales" placeholder="全部" clearable class="w120" >
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="2"></el-option>
              <el-option label="未知" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="授权删除低效品：">
            <el-select v-model="searchData.low_sales_product_delete_authorized" placeholder="全部" clearable class="w120">
              <el-option label="开启" value="1"></el-option>
              <el-option label="关闭" value="0"></el-option>
            </el-select>
          </el-form-item>
          <div class="gx-bb__spacer"></div>
          <button type="button" class="gx-bb__btn gx-bb__btn--danger" @click="handleSearch">查询</button>
          <button type="button" class="gx-bb__btn" @click="handleReset">重置</button>
        </el-form>
        <div class="gx-bb__filter-tip" v-if="searchData.shop_type===1">动销率状态选项：未达标（＜1%）/ 已达标（≥1%）  ·  授权下架低效品：开启（已授权自动下架低效品）/ 关闭</div>
      </template>

    </div>

    <!--表格+分页-->
    <div class="table-page-wrapper">
        <div class="gx-bb__table">
          <table>
            <thead>
            <tr>
              <th :colspan="3">店铺信息</th>
              <th class="bg-red"><span class="text-red">额度管控</span></th>
              <th :colspan="3" class="bg-red" v-if="searchData.shop_type === 1"><span class="text-red" >动销考核（近30天 · 仅本应用商品）</span></th>
              <th :colspan="searchData.shop_type === 1?3:1">风险拦截</th>
              <th>操作</th>
            </tr>
            <tr>
              <th>
                <div>上货状态</div>
                <div class="gx-bb__th-dec">开启/关闭</div>
              </th>
              <th>店铺名称</th>
              <th>分组</th>
              <th class="bg-red">今日铺货额度</th>
              <template v-if="searchData.shop_type === 1">
                <th class="bg-red">
                  <div>动销率</div>
                  <div class="gx-bb__th-dec">目标≥1%</div>
                </th>
                <th class="bg-red">
                  <div>有效销量品</div>
                  <div class="gx-bb__th-dec">近30天</div>
                </th>
                <th class="bg-red">达标差距</th>
                <th>低动销店铺</th>
                <th>
                  <div>授权下架低效品</div>
                  <div class="gx-bb__th-dec">开启/关闭</div>
                </th>
              </template>
              <th>无SKU图拦截</th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in list" :key="row.shop_id || i">
                <td>
                  <button class="gx-bb__switch" :class="{ 'gx-bb__switch--on': row.daily_status == 2 }"  @click="toggleStatus(row)">
                    <span class="gx-bb__switch-dot"></span>
                  </button>
                </td>
                <td>
                  <div class="gx-bb__shop">
                    <div class="gx-bb__shop-icon">{{row.shop_name[0]}}</div>
                    <div style="min-width: 0">
                      <div class="gx-bb__shop-name">{{ row.shop_name || '--' }}</div>
                      <div class="gx-bb__shop-id">ID:{{ row.shop_id || '--' }}</div>
                    </div>
                  </div>
                </td>
                <td><span :class="{'gx-bb__tag--danger':row.group_name}">{{ row.group_name || '--' }}</span></td>
                <td class="bg-red">
                  <div class="gx-bb__quota">
                    <div class="gx-bb__quota-item">
                      <div class="gx-bb__td-num text-black">{{ formatQuantity(row.daily_publish_quota) }}</div>
                      <div class="gx-bb__td-label">总额度</div>
                    </div>
                    <div class="gx-bb__quota-item">
                      <div class="gx-bb__td-num text-orange">{{ formatQuantity(row.today_success) }}</div>
                      <div class="gx-bb__td-label">已上</div>
                    </div>
                    <div class="gx-bb__quota-item">
                      <div class="gx-bb__td-num text-green">{{ getRemainingQuota(row) }}</div>
                      <div class="gx-bb__td-label">剩余</div>
                    </div>
                  </div>
                </td>
                <template  v-if="searchData.shop_type === 1">
                  <td class="bg-red">
                    <div class="gx-bb__td-num" :class="getSalesAssessmentClass(row)">{{ formatSalesRate(row) }}</div>
                    <div class="gx-bb__td-label">{{ getSalesAssessmentLabel(row) }}</div>
                  </td>
                  <td class="bg-red">
                    <div class="gx-bb__td-num" :class="getSalesAssessmentClass(row)">{{ formatEffectiveSalesProductCount(row) }}</div>
                    <div class="gx-bb__td-label">{{ formatAppWindowOnlineProductCount(row) }}</div>
                  </td>
                  <td class="bg-red">
                    <div class="gx-bb__td-num" :class="getSalesAssessmentClass(row)">{{ formatSalesGap(row) }}</div>
                    <div class="gx-bb__td-label">{{ formatSalesTarget(row) }}</div>
                  </td>
                  <td>
                    <span class="gx-bb__tag gx-bb__tag--success" v-if="getShopQuota(row) && getShopQuota(row).is_low_sales_shop===true" type="danger">是</span>
                    <span class="gx-bb__tag gx-bb__tag--danger" v-else-if="getShopQuota(row) && getShopQuota(row).is_low_sales_shop===false" type="success">否</span>
                    <span class="gx-bb__tag gx-bb__tag--info" v-else type="info">未知</span>
                  </td>
                  <td>
                    <button class="gx-bb__switch" :class="{ 'gx-bb__switch--on': row.low_sales_product_delete_authorized == 1 }"  @click="updateLowSalesAuth(row)">
                      <span class="gx-bb__switch-dot"></span>
                    </button>
                  </td>
                </template>
                <td>
                  <!-- is_sku_miss_off 1是 2否-->
                  <span class="gx-bb__tag" :class="row.is_sku_miss_off == 2 ? 'gx-bb__tag--success' : 'gx-bb__tag--warn'">{{ row.is_sku_miss_off == 2 ? '通过' : '拦截中' }}</span>
                </td>
                <td>
                  <div class="gx-bb__ops">
                    <button class="gx-bb__op gx-bb__op--edit" @click="manageShop(row)">编辑</button>
                  </div>
                </td>
              </tr>
              <tr v-if="!list.length">
                <td :colspan="11" class="gx-bb__empty">暂无盲盒数据</td>
              </tr>
            </tbody>
          </table>
        </div>

      <div class="page-wrap">
        <Pagination :total="pageData.total" :page.sync="pageData.page" :limit.sync="pageData.limit" :page-sizes="[ 20, 50, 100, 200]" @pagination="getTableData(pageData.page)"  layout="total, sizes, prev, pager, next, jumper" />
      </div>
    </div>

    <!-- ========== 抖店编辑弹窗 ========== -->
    <div v-if="editShow && editType === 'douyin' && currentShop.shop_id" class="gx-modal" @click.self="closeEdit">
      <div class="gx-modal-box gx-bb__modal-box--xl">
        <div class="gx-modal-head">
          <div class="gx-modal-head-title">
            <span class="gx-modal-title">编辑盲盒配置 - {{ currentShop.shop_name }}</span>
            <span class="gx-bb__tag gx-bb__tag--mi gx-bb__tag--danger">抖店</span>
          </div>
          <button class="gx-modal-close" @click="closeEdit">✕</button>
        </div>
        <div class="gx-modal-body custom-el-wrapper">
          <el-form size="mini" label-width="140px" label-position="left" class="gx-bb__form">
            <el-form-item label="铺货限价">
              <el-input-number v-model="currentShop.shop_limit_price" :controls="false" :min="0" :precision="2" class="w250"></el-input-number>
              <div class="gx-bb__tip gx-bb__tip--red">不得输入小于0的数值，限价指的是铺货时，自动过滤价格低于限价的商品。</div>
            </el-form-item>
            <el-form-item label="上架策略">
              <el-select v-model="currentShop.strategies_id" class="w250" placeholder="请选择">
                <el-option v-for="item in strategiesList" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运费模板">
              <el-select v-model="currentShop.shop_freight_template_id" class="w250" placeholder="请选择">
                <el-option v-for="item in freightTemplate" :key="item.id" :label="item.template_name"
                           :value="String(item.id)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="店铺商品来源">
              <el-select v-model="currentShop.shop_product_source" class="w250" placeholder="请选择">
                <!--                <el-option :value="1" label="系统商品"></el-option>-->
                <el-option :value="2" label="云商品库"></el-option>
              </el-select>
            </el-form-item>
            <template v-if="currentShop.shop_product_source==2">
              <el-form-item label="商品sku替换状态">
                <el-select v-model="currentShop.shop_product_repository_skus" multiple clearable placeholder="请选择" style="width: 100%">
                  <el-option :value="1" label="上未替换"></el-option>
                  <el-option :value="2" label="上已替换"></el-option>
                  <el-option :value="3" label="上找不到"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品sku标记状态">
                <el-select v-model="currentShop.shop_product_repository_skus_mark" multiple clearable placeholder="请选择" style="width: 100%">
                  <el-option :value="1" label="未标记"></el-option>
                  <el-option :value="2" label="已标记"></el-option>
                  <el-option :value="3" label="找不到"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="主分组">
                <el-select v-model="currentShop.shop_product_repository_groups" multiple placeholder="不选择则不限制分组" clearable @visible-change="getGroupChilder($event,'visible')" @remove-tag="getGroupChilder($event)" @clear="getGroupChilder()" style="width: 100%">
                  <el-option v-for="group in cloudGroupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="子分组" v-if="currentShop?.shop_product_repository_groups?.length">
                <el-select v-model="currentShop.shop_product_repository_child_groups" multiple placeholder="选择子分组" clearable style="width: 100%">
                  <el-option v-for="group in cloudGroupChilder" :key="group.id" :label="group.name" :value="group.id"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <el-form-item label="抖店上货类目" >
              <el-cascader
                  ref="cateCascader"
                  v-model="selCate"
                  :options="cateList"
                  :props="{multiple: true,value:'category_id',label:'category_name',children:'sub_category'}"
                  :key="cateRandom"
                  clearable
                  @change="changeCateCascader"
                  @remove-tag="removeCateCascader($event)"
                  @visible-change="blurCateCascader($event)"
                  size="mini"
                  style="width: 100%"></el-cascader>
              <p class="gx-bb__tip gx-bb__tip--red">铺货时，抖店预测商品类目与当前预设类目不一致，将会被拦截铺货。<span v-if="currentShop.shop_product_source==1">当前仅支持最多选择【20】个二级类目！</span></p>
            </el-form-item>
            <el-form-item label="类目品牌">
              <el-select v-model="selCateSub" value-key="category_id" filterable multiple clearable placeholder="请选择" style="width: 100%" @change="changeCateSub" @visible-change="getCateBrand($event)" @remove-tag="removeCateSub($event)" >
                <div class="sel-checked-all" style="padding: 2px 20px;">
                  <el-checkbox :indeterminate="isIndeterminate" v-model="cateSubAllChecked" @change="changeCateSubCheckAll">全选</el-checkbox>
                </div>
                <el-option
                    v-for="item in selCateSubOptions"
                    :key="item.category_id"
                    :label="item.path_names"
                    :value="item">
                </el-option>
              </el-select>
              <div class="gx-bb__tip gx-bb__tip--red">
                登录对应店铺，点击“<a href="https://fxg.jinritemai.com/ffa/grs-new/qualification/list" target="_blank">前往查看</a>”店铺类目品牌。仅需配置有品牌的类目，未配置默认使用“无品牌”进行铺货验证
                <el-button type="warning" size="mini" :disabled="isBatchClear" @click="clearNotBrand" v-if="selCateSub.length">一键清除无品牌</el-button>
              </div>
              <div :key="brandRandom" v-if="selCateSub.length">
                <div v-for="(item,index) in Object.keys(subCateBrand)" :key="index"  style="display: flex;align-items: center;margin: 8px 0;">
                  <div style="margin-right: 10px">{{ subCateBrand[item].category_name }}：</div>
                  <el-select v-model="subCateBrand[item].brand" class="w250" placeholder="请选择品牌" value-key="brand_id" @change="changeSubCateBrand($event, item)"
                             :loading="brandListLoading[item]" loading-text="数据加载中">
                    <el-option v-for="brand in brandObjCache[item]" :key="brand.brand_id" :label="brand.name_cn||brand.brand_name"
                               :value="brand"></el-option>
                  </el-select>
                  <el-button size="mini" :loading="brandListLoading[item]"  style="margin-left: 5px" @click="getBrandList(item)">{{brandListLoading[item]?'':'刷新'}}</el-button>
                  <template v-if="brandKeyValues_def[item]&&subCateBrand[item].brand&&subCateBrand[item].brand.brand_id">
                    <span style="margin-left: 10px;color: #999999;" >已存品牌：{{brandKeyValues_def[item].brand_name}}</span>
                    <template v-if="subCateBrand[item].brand.brand_id!=brandKeyValues_def[item].brand_id">
                      &nbsp;<i class="el-icon-right"></i>&nbsp;
                      <span style="color: #999999;">{{subCateBrand[item]?.brand?.name_cn??''}}</span>
                    </template>
                  </template>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="每日铺货数量">
              <el-input-number v-model="currentShop.daily_num" :controls="false" :max="maxAutoNum" :min="0"
                               :precision="0"
                               class="w250"></el-input-number>
            </el-form-item>
            <div v-if="getShopQuota(currentShop) && getShopQuota(currentShop).is_low_sales_shop===true && getShopQuota(currentShop).daily_quota!==null"
                 class="gx-bb__tip gx-bb__tip--red">
              该店铺为低动销店铺，平台每日发品额度 {{getShopQuota(currentShop).daily_quota}}，当日实际可铺货数受此限制。
            </div>
            <el-form-item label="商品无Sku图拦截铺货">
              <el-switch v-model="currentShop.is_sku_miss_off" :active-value="2" :inactive-value="1" size="small"></el-switch>
            </el-form-item>
            <el-form-item label="店铺黑名单叶子类目" >
              <el-cascader
                  ref="blackCateCascader"
                  v-model="selLeafCate"
                  :options="leafCateList"
                  :props="{multiple: true,value:'category_id',label:'category_name',children:'sub_category'}"
                  clearable
                  size="mini"
                  style="width: 100%"></el-cascader>
              <p class="gx-bb__tip gx-bb__tip--red">设置“不允许铺货”的最末级商品类目，商品类目预测时，会先从预测候选叶子类目中排除黑名单项，再返回可用预测结果</p>
            </el-form-item>
            <template v-if="currentShop.shop_product_source==1">
              <div v-for="(item,index) in selSubCate" :key="index">
                <div style="margin-bottom: 6px;font-weight: 700;">{{item.label}}：</div>
                <div class="form-item" >
                  <el-input  v-model="item.search"  placeholder="输入不上关键词" size="small" style="width: 250px;">
                    <el-button slot="append" icon="el-icon-search" :loading="item.loading" @click="searchKeyword(index)"></el-button>
                  </el-input>
                  <el-select v-model="item.keyword" multiple :multiple-limit="10" placeholder="请选择不上关键词" size="small" clearable style="flex: 1">
                    <el-option v-for="(key,i) in item.keyword_arr" :label="key" :value="key" :key="i"></el-option>
                  </el-select>
                </div>
              </div>
            </template>
          </el-form>
        </div>
        <div class="gx-modal-foot gx-modal-foot--bg">
          <button class="gx-modal-foot-btn" @click="closeEdit">关闭</button>
          <button class="gx-modal-foot-btn gx-modal-foot-btn--yellow" :disabled="sLoading" @click="saveShopSettings">
            {{ sLoading ? '保存中...' : '保存设置' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ========== 微信编辑弹窗 ========== -->
    <div v-if="editShow && editType === 'wechat' && currentShop.shop_id" class="gx-modal" @click.self="closeEdit">
      <div class="gx-modal-box gx-bb__modal-box--xl">
        <div class="gx-modal-head">
          <div class="gx-modal-head-title" >
            <span class="gx-modal-title">编辑微信盲盒配置 - {{ currentShop.shop_name }}</span>
            <span class="gx-bb__tag gx-bb__tag--mi gx-bb__tag--success">微信小店</span>
          </div>
          <button class="gx-modal-close" @click="closeEdit">✕</button>
        </div>
        <div class="gx-modal-body custom-el-wrapper">
          <div class="gx-bb__section-title">基础设置</div>
          <el-form size="mini" label-width="110px" label-position="left" class="gx-bb__form">
            <el-form-item label="铺货限价" prop="shop_limit_price">
              <el-input-number v-model="wForm.shop_limit_price" :controls="false" :min="0" :precision="2" class="w250"></el-input-number>
              <div class="gx-bb__tip gx-bb__tip--red">限价指的是铺货时，自动过滤价格低于限价的商品</div>
            </el-form-item>
            <el-form-item label="上架策略" prop="strategies_id">
              <el-select v-model="wForm.strategies_id" class="w250" placeholder="请选择">
                <el-option v-for="item in strategiesList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运费模板" prop="freight_template_id">
              <el-select v-model="wForm.freight_template_id" class="w250" placeholder="请选择">
                <el-option v-for="item in freightTemplate" :key="item.id" :label="item.template_name" :value="String(item.id)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运费险">
              <el-switch v-model="wForm.freight_insurance" ></el-switch>
            </el-form-item>
            <el-form-item label="店铺商品来源">
              <el-input value="云商品库" class="w250" disabled></el-input>
            </el-form-item>
            <el-form-item label="商品sku状态">
              <el-select v-model="wForm.shop_product_repository_skus" multiple placeholder="请选择" style="width: 100%">
                <el-option v-for="item in skuStatusOptions" :key="item.id" :value="item.id" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品分组">
              <el-select v-model="wForm.shop_product_repository_groups" multiple placeholder="不选择则不限制分组" style="width: 100%">
                <el-option v-for="group in cloudGroupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="每日铺货数量" prop="daily_num">
              <el-input-number v-model="wForm.daily_num" :controls="false" :max="maxAutoNum" :min="0" :precision="0" class="w250"></el-input-number>
            </el-form-item>
            <el-form-item label="售后地址" prop="return_address_id">
              <el-select v-model="wForm.return_address_id" class="w250" placeholder="请选择售后地址">
                <el-option v-for="item in wReturnAddressList" :key="item.address_id" :label="formatAddress(item)" :value="item.address_id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="gx-bb__section-title">分类设置</div>
          <div class="gx-bb__tip gx-bb__tip--red" style="margin: 0 0 10px;">需要选择可以正常上货的分类，需要申请类目权限和缴纳对应的保证金，未缴纳保证金将铺货失败！</div>
          <el-form size="mini" label-width="140px" label-position="left" class="gx-bb__form">
            <el-form-item label="微信二级分类">
              <el-cascader
                  v-model="wSelectedCateIds"
                  :options="wCateList"
                  :props="wCateCascaderProps"
                  :popper-append-to-body="false"
                  clearable
                  collapse-tags
                  popper-class="wechat-blind-cate-cascader"
                  size="mini"
                  style="width: 100%"
                  @change="changeWCateCascader">
              </el-cascader>
              <div class="gx-bb__tip gx-bb__tip--red">铺货时，微信预测前三个类目的二级类目与当前预设类目不一致，将会被拦截铺货。</div>
            </el-form-item>
            <el-form-item label="类目品牌">
              <div v-if="wSelectedCateList.length" :key="brandRandom">
                <div v-for="item in wSelectedCateList" :key="item.category_id"
                     style="display: flex;align-items: center;margin: 8px 0;">
                  <div class="brand-cate-name">{{ item.path_names }}：</div>
                  <el-select v-model="item.brand" class="w250" placeholder="请选择品牌" value-key="brand_id">
                    <el-option v-for="brand in wShopBrandList" :key="brand.brand_id" :label="brand.name_cn || brand.brand_name"
                               :value="brand"></el-option>
                  </el-select>
                </div>
              </div>
              <span v-else style="color: #999;font-size: 11px;">请先选择分类</span>
            </el-form-item>
          </el-form>
        </div>
        <div class="gx-modal-foot gx-modal-foot--bg">
          <button class="gx-bb__btn" @click="closeEdit">取消</button>
          <button class="gx-bb__btn gx-bb__btn--primary" :disabled="sLoading" @click="saveWechatSettings">
            {{ sLoading ? '保存中...' : '保存设置' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import PageSizeSelect from '../../components/newUi/PageSizeSelect.vue'
import gxLoading from '../../mixins/gxLoading'
import MultiSelect from '../cloudOptimize/MultiSelect.vue'
import Pagination from "@/components/newUi/Pagination.vue";

export default {
  name: 'NewBlindBoxPage',
  components: {Pagination, MultiSelect, GxLoading, PageSizeSelect },
  mixins: [gxLoading],
  data() {
    return {
      platforms: [
        { value: 1, label: '抖店' },
        { value: 7, label: '微店' }
      ],
      searchData: { shop_type: 1, group_ids: [], shop_name: '', daily_status: '',low_sales:'' },
      groupList: [],
      shopList: [],
      list: [],
      pageData: { limit: 50, page: 1, total: 0 },
      pageSizeOptions: [10, 20, 50, 100, 200],
      is_host: true,
      skuStatusOptions: [
        { id: 1, name: '上未替换' },
        { id: 2, name: '上已替换' },
        { id: 3, name: '上找不到' }
      ],
      // 编辑
      editShow: false,
      editType: 'douyin',
      currentShop: {},
      strategiesList: [],
      freightTemplate: [],
      maxAutoNum: 0,
      defaultNum: 0,
      defaultRatio: 0,
      sLoading: false,
      // 抖店分类/品牌
      cateList: [],
      selCate: [],
      selCateOld: [],
      cateRandom: Math.random(),
      expandedL1: {},
      isIndeterminate:false,
      cateSubAllChecked:false,
      selCateSubOptions: [],
      selCateSub: [],
      subCateBrand: {},
      brandKeyValues_def: {},
      removeCateIds:[],
      brandRandom:Math.random(),
      brandLoading:false,
      brandObjCache: {},
      brandListLoading: {},
      selSubCate: [],
      cloudGroupList: [],
      cloudGroupChilder: [],
      // 微信
      wForm: {
        shop_limit_price: 0, strategies_id: '', freight_template_id: '', freight_insurance: false,
        shop_product_repository_skus: [], shop_product_repository_groups: [], daily_num: 0, return_address_id: ''
      },
      wCateList: [],
      wCateTableData: [],
      wSelectedCateIds: [],
      wSelectedCateList: [],
      wShopBrandList: [],
      wReturnAddressList: [],
      leafToSecondCateMap: {},
      expandedW: {},
      wCateCascaderProps: {
        multiple: true,
        value: 'category_id',
        label: 'category_name',
        children: 'sub_category',
        leaf: 'is_leaf',
        emitPath: true,
        checkStrictly: false
      },

      leafCateList:[],//店铺类目黑名单
      selLeafCate:[],
      unauthorized_quantity:50,//删除低效品授权未开启
      authorized_quantity:500,//删除低效品授权已开启
    }
  },
  computed: {
    ...mapState({
      users: (state) => state.login.userinfo
    }),
    totalPages() {
      return Math.max(1, Math.ceil(this.pageData.total / this.pageData.limit))
    },
    pageNums() {
      const total = this.totalPages
      const nums = []
      const start = Math.max(1, Math.min(this.pageData.page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },

    isBatchClear() {
      const ids = Object.keys(this.brandListLoading)
      return ids.length === 0 || ids.some(item => this.brandListLoading[item])
    }
  },
  created() {
    this.is_host = !(this.$store.state.login.is_host === 'false')
    this.loadGroupList()
    this.getShopList()
    this.getTableData(1)
  },
  methods: {
    ...mapActions({
      getBlindBox: 'ucenter/getBlindBox',
      getBlindBoxDetail: 'ucenter/getBlindBoxDetail',
      updateBlindBox: 'ucenter/updateBlindBox',
      updateBlindBoxStatus: 'ucenter/updateBlindBoxStatus',
      fetchBrandList: 'ucenter/fetchBrandList',
      fetchBrandListBatch: 'ucenter/fetchBrandListBatch',
      fetchCategoryList: 'ucenter/fetchCategoryList',
      fetchWechatCategoryList: 'ucenter/fetchWechatCategoryList',
      fetchPhraseList: 'ucenter/fetchPhraseList',
      opGetTwoCategorySubList: 'ucenter/opGetTwoCategorySubList',
      getDdShopList: 'ucenter/getDdShopList',
      getShopBoardGroupList: 'shop_board/getShopBoardGroupList',
      getCloudProductGroups: 'ucenter/getCloudProductGroups',
      getCloudProductGroupsNew: 'ucenter/getCloudProductGroupsNew',
      fetchLeafCategoryList: 'ucenter/fetchLeafCategoryList',
      opLowSalesProductDeleteAuthorization: "ucenter/opLowSalesProductDeleteAuthorization",
    }),
    keywordOptions(arr) {
      return (arr || []).map(k => ({ id: k, name: k }))
    },
    formatAddress(item) {
      const parts = [item.province, item.city, item.area, item.detail].filter(p => p)
      const address = parts.join('')
      const contact = [item.name, item.phone_number].filter(p => p).join(' ')
      return contact ? `${address}（${contact}）` : address
    },
    setChange() {
      if(this.$store.state.login.user_level == 9 && this.searchData.group_ids) {
        this.searchData.group_ids = []
        this.$message.error('普通会员无法使用分组');
        return
      }
    },
    /**
     *  ── 列表 ── */
    loadGroupList() {
      this.getShopBoardGroupList({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            const list = res.data || []
            if (this.is_host) list.push({ id: -1, name: '未分组' })
            this.groupList = list
          }
        }
      })
    },
    getShopList() {
      this.getDdShopList({
        data: { page_size: 100, page: 1, shop_type: this.searchData.shop_type },
        success: (res) => {
          if (res.code === 200) {
            const d = res.data
            this.shopList = d.list && d.list.list ? d.list.list : (Array.isArray(d.list) ? d.list : [])
            this.unauthorized_quantity = res.data?.unauthorized_quantity??50
            this.authorized_quantity = res.data?.authorized_quantity??500
          }
        }
      })
    },
    bindShopTypeChange(type) {
      if (this.searchData.shop_type === type) return
      this.searchData.shop_type = type
      this.pageData.page = 1
      this.handleReset()
      this.getShopList()
    },
    handleSearch() {
      this.list = []
      this.pageData.page = 1
      this.getTableData(1)
    },
    handleReset() {
      this.searchData.shop_name = ''
      this.searchData.daily_status = ''
      this.searchData.group_ids = []
      this.searchData.low_sales=""
      this.handleSearch()
    },
    onPageSizeChange(size) {
      this.pageData.limit = size
      this.pageData.page = 1
      this.getTableData(1)
    },
    //读取店铺低动销状态（列表接口已返回 shop_product_quota，缺失视为未知）
    getShopQuota(row) {
      return (row && row.shop_product_quota) || { is_low_sales_shop: null, daily_quota: null }
    },
    toFiniteNumber(value) {
      if (value === null || value === undefined || value === '') return null
      const number = Number(value)
      return Number.isFinite(number) ? number : null
    },
    formatQuantity(value) {
      const number = this.toFiniteNumber(value)
      return number === null ? '--' : String(Math.max(0, Math.trunc(number)))
    },
    getRemainingQuota(row) {
      const total = this.toFiniteNumber(row && row.daily_publish_quota)
      const used = this.toFiniteNumber(row && row.today_success)
      return total === null || used === null ? '--' : this.formatQuantity(Math.max(total - used, 0))
    },
    getSalesAssessment(row) {
      return row && row.sales_assessment && typeof row.sales_assessment === 'object'
        ? row.sales_assessment
        : null
    },
    getSalesAssessmentState(row) {
      const assessment = this.getSalesAssessment(row)
      if (!assessment) return 'pending'

      const syncStatus = this.toFiniteNumber(assessment.sync_status)
      const assessmentStatus = this.toFiniteNumber(assessment.assessment_status)
      if (syncStatus === 2) return 'failed'
      if (syncStatus === 0) return 'syncing'
      if (assessmentStatus === 3) return 'not-applicable'
      if (assessmentStatus === 1) return 'qualified'
      if (assessmentStatus === 2) return 'unqualified'
      return 'pending'
    },
    isSalesAssessmentReady(row) {
      return ['qualified', 'unqualified'].includes(this.getSalesAssessmentState(row))
    },
    getSalesAssessmentLabel(row) {
      return {
        qualified: '已达标',
        unqualified: '未达标',
        pending: '待同步',
        syncing: '同步中',
        failed: '同步失败',
        'not-applicable': '不适用'
      }[this.getSalesAssessmentState(row)]
    },
    getSalesAssessmentClass(row) {
      return this.getSalesAssessmentState(row) === 'qualified'
        ? 'text-green'
        : this.getSalesAssessmentState(row) === 'unqualified'
          ? 'text-red'
          : ''
    },
    formatSalesRate(row) {
      if (!this.isSalesAssessmentReady(row)) return '--'
      const rate = this.toFiniteNumber(this.getSalesAssessment(row).sales_rate)
      return rate === null ? '--' : `${(rate * 100).toFixed(2)}%`
    },
    formatEffectiveSalesProductCount(row) {
      if (!this.isSalesAssessmentReady(row)) return '--'
      return this.formatQuantity(this.getSalesAssessment(row).effective_sales_product_count)
    },
    formatAppWindowOnlineProductCount(row) {
      if (!this.isSalesAssessmentReady(row)) return this.getSalesAssessmentLabel(row)
      return `本应用在售 ${this.formatQuantity(this.getSalesAssessment(row).app_window_online_product_count)} 件`
    },
    formatSalesGap(row) {
      const state = this.getSalesAssessmentState(row)
      if (state === 'qualified') return '已达标'
      if (state !== 'unqualified') return '--'
      const gap = this.formatQuantity(this.getSalesAssessment(row).gap_product_count)
      return gap === '--' ? '--' : `差 ${gap} 件`
    },
    formatSalesTarget(row) {
      if (!this.isSalesAssessmentReady(row)) return this.getSalesAssessmentLabel(row)
      const target = this.formatQuantity(this.getSalesAssessment(row).target_product_count)
      return target === '--' ? '--' : `目标 ${target} 件`
    },
    getTableData(page) {
      this.pageData.page = page || this.pageData.page
      const param = { page_size: this.pageData.limit, page: this.pageData.page, ...this.searchData }
      this.loadingStart()
      this.getBlindBox({
        data: param,
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.list = res.data.list || []
            this.pageData.total = res.data.total || 0
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    toggleStatus(row) {
      const target = row.daily_status === 2 ? 1 : 2
      this.$confirm(`确定${target === 2 ? '启用' : '停用'}店铺「${row.shop_name}」的盲盒吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateBlindBoxStatus({
          data: { shop_id: row.shop_id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.message)
              this.getTableData(this.pageData.page)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },

    /**
     *  ── 低效品下架授权 ── */
    updateLowSalesAuth(row){
      const status = row.low_sales_product_delete_authorized == 1 ? 0 : 1
      const params={shop_ids:[row.shop_id],low_sales_product_delete_authorized:status}
      let tip=`关闭授权的店铺，每日铺货默认按 ${this.unauthorized_quantity} 个执行；若平台接口返回额度低于 ${this.unauthorized_quantity} 个，则按接口额度执行。`
      if(status==1) tip=`开启授权后，店铺每日铺货默认按 ${this.authorized_quantity} 个执行；若平台接口返回额度（含低动销店铺）低于 ${this.authorized_quantity} 个，则按接口额度执行。`
      this.$confirm(tip,"提示",{
        showCancelButton:true
      }).then(()=>{
        this.opLowSalesProductDeleteAuthorization({
          data:params,
          success:(res)=>{
            if(res.code==200){
              this.$message.success(`${row.shop_name}已成功${status==1?'开启':'关闭'}店铺的低效品下架授权。`)
              this.getTableData(this.pageData.page)
            }else {
              this.$message.error(res.msg||res.message||'操作失败，请稍后重试')
            }
          },
          fail:()=>{
            this.$message.error('网络异常，请稍后重试')
          }
        })
      }).catch(() => {})
    },
    /**
     * ── 编辑入口 ── */
    async manageShop(shop) {
      this.currentShop = { ...shop }
      this.sLoading = false
      if (this.searchData.shop_type === 7) {
        await this.openWechatEdit(shop)
        return
      }
      this.editType = 'douyin'
      this.editShow = true
      // 编辑弹窗打开后，类目列表与盲盒详情接口加载期间显示全屏loading
      this.loadingStart()
      this.cateList=await this.getCataList()
      this.leafCateList=await this.getLeafCateList()
      this.formatCategory(this.cateList)
      this.formatCategory(this.leafCateList)
      this.manageTitle = '编辑 - '+shop.shop_name
      this.selCate = []
      this.selCateOld = []
      this.subCateBrand ={}
      this.brandObjCache = {}
      this.brandKeyValues_def={...shop.brandKeyValues}
      this.selLeafCate =[]
      this.$set(this.currentShop, 'shop_product_source', shop?.shop_product_source ?? 2)
      if(this.currentShop.shop_product_source==1) this.currentShop.shop_product_source=2
      this.$set(this.currentShop, 'shop_product_repository_skus', shop?.shop_product_repository_skus ?? [])
      this.$set(this.currentShop, 'shop_product_repository_skus_mark', shop?.shop_product_repository_skus_mark ?? [])
      // 确保分组ID为数字类型
      const groups = shop?.shop_product_repository_groups ?? []
      const groups_child = shop?.shop_product_repository_child_groups ?? []
      this.$set(this.currentShop, 'shop_product_repository_groups', Array.isArray(groups) ? groups.map(id => Number(id)) : [])
      this.$set(this.currentShop, 'shop_product_repository_child_groups', Array.isArray(groups_child) ? groups_child.map(id => Number(id)) : [])
      this.loadCloudGroupList()
      this.getGroupChilder()
      if(shop.categoryIds){
        let arr = shop.categoryIds.split(',')
        this.cateList.forEach(item=>{
          this.setSelCate(arr,item,this.selCate,[])
        })
        this.$nextTick(()=>{
          this.getTwoCategorySubList(true)
        })
      }
      if (shop?.shop_category_blacklist_leaf_ids?.length){
        // 递归遍历至最底层，回填所有层级的黑名单叶子类目
        this.leafCateList.forEach(item=>{
          this.setSelCate(shop.shop_category_blacklist_leaf_ids,item,this.selLeafCate,[])
        })
      }

      this.getBlindBoxDetail({
        data: { shop_id: shop.shop_id, shop_type: this.searchData.shop_type },
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.freightTemplate = (res.data.shop_freight_template_list || []).map(item => item.template)
            this.strategiesList = res.data.strategies_list || []
            this.maxAutoNum = Number(res.data.max_auto_num) || 0
            this.defaultNum = Number(res.data.default_num) || 0
            this.defaultRatio = Number(res.data.default_ratio) || 0
            this.buildSelSubCate()
          } else {
            this.$message.error(res.message)
          }
        }
      })


    },
    async openWechatEdit(shop) {
      this.editType = 'wechat'
      this.editShow = true
      // 编辑弹窗打开后，微信类目与盲盒详情接口加载期间显示全屏loading
      this.loadingStart()
      this.cloudGroupList = []
      this.wSelectedCateIds = []
      this.wSelectedCateList = []
      this.wShopBrandList = []
      this.wReturnAddressList = []
      this.expandedW = {}
      this.loadCloudGroupList()
      this.wCateList = await this.loadWechatCateList(shop.shop_id)
      this.getBlindBoxDetail({
        data: { shop_id: shop.shop_id, shop_type: 7 },
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            const data = res.data
            this.strategiesList = data.strategies_list || []
            this.freightTemplate = (data.shop_freight_template_list || []).map(item => item.template)
            this.maxAutoNum = Number(data.max_auto_num) || 0
            this.wShopBrandList = data.shop_brand_list || []
            this.wReturnAddressList = data.shop_return_address_list || []
            this.wForm.shop_limit_price = data.shop_limit_price || 0
            this.wForm.strategies_id = data.strategies_id || ''
            this.wForm.freight_template_id = data.shop_freight_template_id ? String(data.shop_freight_template_id) : ''
            this.wForm.freight_insurance = data.freight_insurance == 1
            // 微信盲盒当前仅支持云商品库，历史系统商品配置进入编辑页时也固定为云商品库。
            this.wForm.shop_product_source = 2
            this.wForm.shop_product_repository_skus = Array.isArray(data.shop_product_repository_skus) ? data.shop_product_repository_skus : []
            const groups = Array.isArray(data.shop_product_repository_groups) ? data.shop_product_repository_groups : []
            this.wForm.shop_product_repository_groups = groups.map(id => Number(id))
            this.wForm.daily_num = data.daily_num || 0
            // 售后地址：优先使用已保存的，否则默认选择第一条
            this.wForm.return_address_id = data.return_address_id || (this.wReturnAddressList.length ? this.wReturnAddressList[0].address_id : '')
            this.defaultNum = Number(data.default_num) || 0
            if (data.categoryIds) {
              const ids = data.categoryIds.split(',').map(id => String(id).trim())
              const secondIds = [...new Set(ids.map(id => String(this.getSecondCategoryId(id))))]
              const brandKeyValues = data.brandKeyValues || {}
              this.wSelectedCateList = this.wCateTableData
                .filter(item => secondIds.includes(String(item.category_id)))
                .map(item => {
                  const oldCategoryId = ids.find(id => String(this.getSecondCategoryId(id)) === String(item.category_id))
                  const brandData = brandKeyValues[item.category_id] || brandKeyValues[String(item.category_id)] || brandKeyValues[oldCategoryId] || brandKeyValues[String(oldCategoryId)] || brandKeyValues[item.level1_id] || brandKeyValues[String(item.level1_id)] || null
                  return { ...item, brand: brandData, limit_num: this.defaultNum }
                })
              this.wSelectedCateIds = this.wSelectedCateList.map(item => item.cate_path)
              this.wSelectedCateIds.forEach(path => {
                if (path[0]) this.$set(this.expandedW, path[0], true)
              })
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    /**
     *  ── 抖店分类/品牌 ── */
    getCataList() {
      return new Promise((resolve) => {
        this.fetchCategoryList({
          data: { shop_id: this.currentShop.shop_id },
          success: (res) => {
            if (res.code === 200) resolve( res.data|| [])
            else {
              resolve([])
              this.$message.error(res.message)
            }
          }
        })
      })
    },
    //获取店铺类目黑名单
    getLeafCateList() {
      return new Promise((resolve, reject) => {
        this.fetchLeafCategoryList({
          data: {shop_id:this.currentShop.shop_id}, success: (res) => {
            if (res.code == 200) {
              resolve(res.data||[])
            } else {
              resolve([])
              this.$message.error(res.message)
            }
          }
        })
      })
    },
    //类目数据格式化
    formatCategory(list){
      if(list.length){
        list.forEach(item=>{
          if(item?.sub_category?.length){
            this.formatCategory(item.sub_category)
          }else{
            delete item.sub_category
          }
        })
      }
    },
    //类目回显
    setSelCate(ids,cate,selList,idArr){
      idArr.push(cate.category_id)
      if(cate?.sub_category?.length){
        cate.sub_category.forEach(item=>{
          // 传入副本，避免兄弟节点递归时污染已记录的路径
          this.setSelCate(ids,item,selList,[...idArr])
        })
      }else if(ids.includes(cate.category_id)||ids.includes(String(cate.category_id))){
        selList.push(idArr)
      }
    },
    //一级、二级类目选择
    changeCateCascader(init){
      if (!init&&this.currentShop.shop_product_source==1&&this.selCate?.length > 20) {
        // 移除最后一个选择的项，以保持不超过 maxSelections 个选项
        this.$message.warning('最多只能选择 20 个选项，请进行删减');
      }
      if(!this.selCate||!this.selCate.length){
        this.selCateSubOptions=[]
        this.selCateSub=[]
        this.subCateBrand={}
        this.getCateBrand(false)
      }
    },
    removeCateCascader(e){
      let arr = this.selCate.filter(item=>item[0]!=e[0]||(item[0]==e[0]&&item[1]!=e[1]))
      this.selCate = arr
      this.cateRandom = Math.random()
      if(!arr.length) {
        this.selCateSubOptions=[]
        this.selCateSub=[]
        this.subCateBrand={}
        this.getCateBrand(false)
        return false
      }
      this.getTwoCategorySubList()
    },
    blurCateCascader(e){
      if(e) return
      this.getTwoCategorySubList()
    },
    //获取二级类目下级叶子类目
    getTwoCategorySubList(init) {
      const arr = this.selCate.map(item => item[1])
      if (!arr.length) {
        this.selCateSubOptions = []
        return false
      }
      const ids = arr.join(',')
      this.opGetTwoCategorySubList({
        data: { category_two_ids: ids },
        success: (res) => {
          if (res.code === 200) {
            this.selCateSubOptions = res.data || []
            if (init) {
              const keys = Object.keys(this.brandKeyValues_def)
              this.selCateSub = this.selCateSubOptions.filter(i => keys.includes(String(i.category_id)))
              this.getCateBrand(true)
            } else {
              const optionIdArr = this.selCateSubOptions.map(item => String(item.category_id))
              this.selCateSub = this.selCateSub.filter(i => optionIdArr.includes(String(i.category_id)))
              const brandCateIdArr = Object.keys(this.subCateBrand)
              const delCataIdArr = brandCateIdArr.filter(item => !optionIdArr.includes(String(item)))
              delCataIdArr.forEach(item => {
                delete this.subCateBrand[item]
              })
            }
          }
        }
      })
    },

    //子（三）级类目(即品牌类目)选择——全选
    changeCateSubCheckAll(val){
      this.selCateSub = val?this.selCateSubOptions:[]
      this.isIndeterminate=false
    },
    //子（三）级类目(即品牌类目)选择
    changeCateSub(){
      this.cateSubAllChecked = this.selCateSub.length === this.selCateSubOptions.length
      this.isIndeterminate=this.selCateSub.length>0 && this.selCateSub.length<this.selCateSubOptions.length
      if(!this.selCateSub.length){
        this.brandLoading =false
        this.subCateBrand={}
      }
    },
    removeCateSub(e){
      if(!this.brandLoading){
        delete this.subCateBrand[e.category_id]
        this.brandRandom  =Math.random()
      }else{
        this.removeCateIds.push(e.category_id)
        this.brandLoading =false
        this.getCateBrand(false)
      }
    },

    //品牌类目下的品牌
    async getCateBrand(e,init) {
      this.brandLoading = false
      if(e) return false
      try {
        this.brandLoading = true
        if (!this.selCateSub.length){
          this.subCateBrand={}
          this.brandLoading = false
          return
        }
        //新已选类目ID数组
        const selCateIdArr =this.selCateSub.map(item=>item.category_id)
        //已缓存的类目品牌的类目ID
        const ycCateIdArr=Object.keys(this.brandObjCache)
        //待缓存的类目ID
        const addCateIdArr = selCateIdArr.filter(item=>!ycCateIdArr.includes(String(item)))

        //更新已选类目对应的品牌
        Object.keys(this.subCateBrand).forEach(item => {
          if (!selCateIdArr.includes(item)) delete this.subCateBrand[item]
        })

        for (var item of this.selCateSub){
          if(!this.brandLoading){
            if(!this.selCateSub.length){
              this.subCateBrand={}
            }
            break;
          }
          if(!ycCateIdArr.includes(String(item.category_id))){
            this.$set(this.brandListLoading,item.category_id,true)
          }
          let obj={}
          if(!this.subCateBrand[item.category_id]){
            const defaultBrand = this.brandObjCache[item.category_id]&&this.brandObjCache[item.category_id].length===1?this.brandObjCache[item.category_id][0]:null
            obj = {
              category_id: item.category_id,
              category_name: item.path_names,
              // brand:this.brandKeyValues_def[item.category_id],
              brand:this.brandKeyValues_def[item.category_id]||defaultBrand,
            }
          }
          this.subCateBrand[item.category_id]=obj
          this.brandRandom  =Math.random()
        }

        //获取未缓存的类目品牌
        for(var j=1;j<=Math.ceil(addCateIdArr.length/10);j++){
          if(!this.brandLoading){
            addCateIdArr.forEach(item=>{
              this.$set(this.brandListLoading,item,false)
            })
            break;
          }
          let ids = addCateIdArr.slice((j-1)*10,j*10)
          let res = await this.getBrandListBatch(ids)
          let list = res.list
          this.brandObjCache=Object.assign(list,this.brandObjCache)
          ids.forEach(item=>{
            this.$set(this.brandListLoading,item,false)
            if((!init||(init&&(!this.subCateBrand[item].brand||!this.subCateBrand[item].brand.brand_id)))&&this.brandObjCache[item].length===1){
              this.subCateBrand[item].brand = this.brandObjCache[item][0]
            }
          })
        }
      } catch (e) {
        this.$message.error(e.message)
      }finally {
        if(this.removeCateIds.length){
          for(var key of this.removeCateIds){
            delete this.subCateBrand[key]
          }
          this.brandRandom  =Math.random()
          this.removeCateIds=[]
        }
        this.selCateOld=[...this.selCate]
        this.brandLoading =false
      }

    },
    getBrandList(id) {
      return new Promise((resolve) => {
        this.$set(this.brandListLoading, id, true)
        this.fetchBrandList({
          data: { shop_id: this.currentShop.shop_id, category_head_id: id },
          success: (res) => {
            this.$set(this.brandListLoading, id, false)
            if (res.code === 200) {
              this.brandObjCache[id] = res.data
              resolve(res.data)
            } else {
              this.$message.error(res.message)
              resolve([])
            }
          }
        })
      })
    },
    getBrandListBatch(ids) {
      return new Promise((resolve) => {
        this.fetchBrandListBatch({
          data: { shop_type: this.searchData.shop_type, shop_id: this.currentShop.shop_id, category_ids: ids.join(',') },
          success: (res) => {
            if (res.code === 200) resolve(res.data)
            else {
              this.$message.error(res.message)
              resolve({})
            }
          }
        })
      })
    },
    changeSubCateBrand(e,id){
      this.brandRandom=Math.random()
      const name =this.subCateBrand[id].brand.name_cn||this.subCateBrand[id].brand.brand_name
      this.$set(this.subCateBrand[id],'new_brand_name',name)
    },

    //一键清除无品牌
    clearNotBrand() {
      const idArr =Object.keys(this.subCateBrand)
      let delArr=[]
      idArr.forEach(key=>{
        if(this.subCateBrand[key].brand&&(this.subCateBrand[key].brand.name_cn==='无品牌'||this.subCateBrand[key].brand.brand_name==='无品牌')){
          delArr.push(key)
          delete this.subCateBrand[key]
        }
      })

      const newSelCateSub = this.selCateSub.filter(item=>!delArr.includes(String(item.category_id)))
      this.selCateSub = newSelCateSub
      this.cateSubAllChecked = this.selCateSub.length === this.selCateSubOptions.length
      this.isIndeterminate=this.selCateSub.length>0 && this.selCateSub.length<this.selCateSubOptions.length

    },
    /**
     *  ── 不上关键词 ── */
    buildSelSubCate() {
      let categoryLimitKeyValues = this.currentShop.categoryLimitKeyValues||{}
      let _list = this.$refs.cateCascader.getCheckedNodes(true)
      this.selSubCate = _list.map(item=>{
        let limitData={...categoryLimitKeyValues[item.value]}
        return {
          value:item.value,
          label: item.data.path_names,
          limit_num:limitData?.num??this.defaultNum,
          limit_ratio:limitData?.ratio??this.defaultRatio,
          loading: false,
          keyword: limitData&&limitData.filter_keywords?limitData.filter_keywords.split(','):[],
          keyword_arr: [],
          search: '',
        }
      })
    },

    searchKeyword(index) {
      const keyword = this.selSubCate[index].search
      if (!keyword) {
        this.$message.warning('请输入要搜索的关键词')
        return
      }
      this.selSubCate[index].loading = true
      this.fetchPhraseList({
        data: { title: keyword },
        success: (res) => {
          this.selSubCate[index].loading = false
          if (res.code === 200) {
            this.selSubCate[index].keyword_arr = res.data || []
            this.$message.success('请在后面的选择框中选择')
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    /**
     *  ── 云商品库分组 ── */
    loadCloudGroupList() {
      this.getCloudProductGroups({
        data: { with_count: 0 },
        success: (res) => {
          if (res.code === 200) this.cloudGroupList = res.data || []
        }
      })
    },
    //获取主分组下了子分组
    getGroupChilder(e,type) {
      if(e&&type==='visible') return
      if (!this.currentShop.shop_product_repository_groups || !this.currentShop.shop_product_repository_groups.length) {
        this.cloudGroupChilder = []
        this.currentShop.shop_product_repository_child_groups = []
        return
      }
      this.getCloudProductGroupsNew({
        data: { page: 1, page_size: 100, parent_ids: this.currentShop.shop_product_repository_groups },
        success: (res) => {
          if (res.code === 200) {
            this.cloudGroupChilder = res?.data?.list ?? []
            const idArr = this.cloudGroupChilder.map(item => item.id)
            this.currentShop.shop_product_repository_child_groups = this.currentShop.shop_product_repository_child_groups.filter(id => idArr.includes(id))
          }
        }
      })
    },
    changeProductSource() {
      this.currentShop.shop_product_repository_skus = []
      this.buildSelSubCate()
    },
    /**
     *  ── 保存（抖店） ── */
    saveShopSettings() {
      try {
        this.sLoading = true
        const obj_f = this.freightTemplate.find(i => i.id == this.currentShop.shop_freight_template_id)
       const categoryIds = this.$refs.cateCascader.getCheckedNodes(true).map(item => {
          return item.value
        })
        const blackCateIds = this.$refs.blackCateCascader.getCheckedNodes(true).map(item => {
          return item.value
        })
        const brandKeyValues = {}
        let cateBrandObj=this.subCateBrand
        for (var brand of this.selCateSub){
          let item={}
          if(cateBrandObj[brand.category_id]&&cateBrandObj[brand.category_id].brand&&cateBrandObj[brand.category_id].brand.brand_id){
            item=cateBrandObj[brand.category_id].brand
          }else if(this.brandKeyValues_def[brand.category_id]){
            item=this.brandKeyValues_def[brand.category_id]
          }else{
            throw '请选择类目品牌'
          }
          brandKeyValues[brand.category_id] = {brand_id: item.brand_id||'', brand_name: item.name_cn||item.brand_name}
        }
        const categoryLimitKeyValues = {}
        if(this.currentShop.shop_product_source==1){
          this.selSubCate.forEach(item => {
            // if (!item.limit_num){
            //   throw '请填写铺货数量'
            // }
            /*  if (!item.limit_ratio){
                throw '请填写铺货比例'
              }*/
            categoryLimitKeyValues[item.value] = {ratio: item.limit_ratio,num: item.limit_num, filter_keywords: item.keyword.join(',')}
          })
        }
        const params = {
          shop_type:this.searchData.shop_type,
          shop_id: this.currentShop.shop_id,
          shop_limit_price: this.currentShop.shop_limit_price,
          daily_num: this.currentShop.daily_num,
          strategies_id: this.currentShop.strategies_id,
          shop_category_id: this.currentShop.shop_category_id,
          freight_template_id: this.currentShop.shop_freight_template_id,
          shop_product_source: this.currentShop.shop_product_source,
          shop_product_repository_skus: this.currentShop.shop_product_repository_skus,
          shop_product_repository_groups: this.currentShop.shop_product_repository_groups,
          shop_product_repository_child_groups: this.currentShop.shop_product_repository_child_groups,
          is_sku_miss_off: this.currentShop.is_sku_miss_off,
          freight_template_name: obj_f.template_name,
          categoryIds: categoryIds.join(','),
          brandKeyValues: brandKeyValues,
          categoryLimitKeyValues:categoryLimitKeyValues,
          shop_product_repository_skus_mark:this.currentShop.shop_product_repository_skus_mark,
          shop_category_blacklist_leaf_ids:blackCateIds,
        }
        if(params.shop_product_source==1) {
          delete params.shop_product_repository_skus
          delete params.shop_product_repository_groups
        }
        if(params.shop_product_source==2) delete params.categoryLimitKeyValues
        this.updateBlindBox({
          data: params, success: (res) => {
            this.sLoading = false
            if (res.code == 200) {
              this.closeEdit()
              this.$message({message: res.message, type: 'success'})
              this.getTableData(this.pageData.page)
            } else {
              this.$message({message: res.message, type: 'error'})
            }
          }
        })
      } catch (e) {
        this.$message.error(e)
        this.sLoading = false
      }
    },
    /**
     *  ── 微信分类 ── */
    loadWechatCateList(shopId) {
      return new Promise((resolve) => {
        this.fetchWechatCategoryList({
          data: { shop_id: shopId },
          success: (res) => {
            if (res.code === 200) {
              const nodes = res.data || []
              this.leafToSecondCateMap = this.buildLeafToSecondCateMap(nodes)
              this.wCateList = this.buildSecondLevelCateTree(nodes)
              this.wCateTableData = this.flattenCateTree(this.wCateList)
              resolve(this.wCateList)
            } else {
              this.$message.error(res.message)
              resolve([])
            }
          }
        })
      })
    },
    buildSecondLevelCateTree(nodes) {
      return (nodes || []).map(item => {
        const children = (item.sub_category || []).map(second => {
          const { sub_category, ...secondCate } = second
          return { ...secondCate, is_leaf: true }
        })
        return { ...item, sub_category: children }
      }).filter(item => item.sub_category && item.sub_category.length)
    },
    buildLeafToSecondCateMap(nodes) {
      const map = {}
      const walk = (node, secondId) => {
        if (!node) return
        map[String(node.category_id)] = secondId
        ;(node.sub_category || []).forEach(child => walk(child, secondId))
      }
      ;(nodes || []).forEach(root => {
        ;(root.sub_category || []).forEach(second => walk(second, second.category_id))
      })
      return map
    },
    getSecondCategoryId(categoryId) {
      return this.leafToSecondCateMap[String(categoryId)] || categoryId
    },
    flattenCateTree(nodes, level1 = '', level2 = '', level3 = '', level1_id = null, level2_id = null, level3_id = null) {
      const result = []
      const flatten = (nodes, l1, l2, l3, l1_id, l2_id, l3_id) => {
        nodes.forEach(node => {
          if (node.is_leaf) {
            const pathParts = node.path_names.split('>')
            const depth = pathParts.length
            const rowData = {
              row_key: `${node.category_id}`,
              category_id: node.category_id,
              path_names: node.path_names,
              cate_path: [l1_id, l2_id, l3_id, node.category_id].filter(id => id !== null && id !== undefined),
              level1_id: l1_id,
              level2_id: l2_id,
              level3_id: l3_id
            }
            if (depth === 2) {
              rowData.level1_name = l1
              rowData.level2_name = node.category_name
              rowData.level2_id = node.category_id
            } else {
              rowData.level1_name = l1
              rowData.level2_name = node.category_name
              rowData.level2_id = node.category_id
            }
            result.push(rowData)
          } else if (node.sub_category && node.sub_category.length) {
            const pathParts = node.path_names.split('>')
            const depth = pathParts.length
            if (depth === 1) {
              flatten(node.sub_category, node.category_name, '', '', node.category_id, null, null)
            } else if (depth === 2) {
              flatten(node.sub_category, l1, node.category_name, '', l1_id, node.category_id, null)
            } else if (depth === 3) {
              flatten(node.sub_category, l1, l2, node.category_name, l1_id, l2_id, node.category_id)
            }
          }
        })
      }
      flatten(nodes, level1, level2, level3, level1_id, level2_id, level3_id)
      return result
    },
    toggleExpandW(id) {
      this.$set(this.expandedW, id, !this.expandedW[id])
    },
    isWCateSelected(l1, l2) {
      return this.wSelectedCateIds.some(path => String(path[path.length - 1]) === String(l2))
    },
    toggleWCate(l1, l2, checked) {
      const path = [l1.category_id, l2.category_id]
      if (checked) {
        if (!this.wSelectedCateIds.some(p => String(p[p.length - 1]) === String(l2.category_id))) {
          this.wSelectedCateIds.push(path)
        }
        this.$set(this.expandedW, l1.category_id, true)
      } else {
        this.wSelectedCateIds = this.wSelectedCateIds.filter(p => String(p[p.length - 1]) !== String(l2.category_id))
      }
      const secondIds = this.wSelectedCateIds.map(item => String(item[item.length - 1]))
      const oldMap = {}
      this.wSelectedCateList.forEach(item => {
        oldMap[item.category_id] = item
      })
      this.wSelectedCateList = this.wCateTableData
        .filter(item => secondIds.includes(String(item.category_id)))
        .map(item => {
          const old = oldMap[item.category_id] || {}
          return { ...item, brand: old.brand || null, limit_num: old.limit_num || this.defaultNum }
        })
    },
    removeWCate(item) {
      this.wSelectedCateIds = this.wSelectedCateIds.filter(p => String(p[p.length - 1]) !== String(item.category_id))
      this.wSelectedCateList = this.wSelectedCateList.filter(i => i.category_id != item.category_id)
    },
    // 级联类目变更后同步已选类目，保留已有品牌和关键词设置。
    changeWCateCascader(value) {
      const validPaths = value.filter(item => item.length >= 2)
      const secondIds = validPaths.map(item => String(item[item.length - 1]))
      this.wSelectedCateIds = validPaths
      const oldMap = {}
      this.wSelectedCateList.forEach(item => {
        oldMap[item.category_id] = item
      })
      this.wSelectedCateList = this.wCateTableData
          .filter(item => secondIds.includes(String(item.category_id)))
          .map(item => {
            const old = oldMap[item.category_id] || {}
            return {
              ...item,
              brand: old.brand || null,
              limit_num: old.limit_num || this.defaultNum
            }
          })
      this.brandRandom = Math.random()
    },
    /**
     *  ── 保存（微信） ── */
    saveWechatSettings() {
      try {
        if (!this.wForm.shop_product_repository_skus.length) {
          this.$message.error('请选择云商品库铺货商品sku状态')
          return
        }
        const categoryIds = this.wSelectedCateList.map(item => item.category_id)
        const brandKeyValues = {}
        this.wSelectedCateList.forEach(item => {
          if (item.brand && item.brand.brand_id) {
            brandKeyValues[item.category_id] = {
              brand_id: item.brand.brand_id,
              brand_name: item.brand.name_cn || item.brand.brand_name
            }
          }
        })
        const freightItem = this.freightTemplate.find(i => i.id == this.wForm.freight_template_id)
        const params = {
          shop_id: this.currentShop.shop_id,
          shop_type: 7,
          shop_limit_price: this.wForm.shop_limit_price,
          daily_num: this.wForm.daily_num,
          strategies_id: this.wForm.strategies_id,
          freight_template_id: this.wForm.freight_template_id,
          freight_template_name: freightItem ? freightItem.template_name : '',
          freight_insurance: this.wForm.freight_insurance ? 1 : 0,
          return_address_id: this.wForm.return_address_id,
          shop_product_source: 2,
          shop_product_repository_skus: this.wForm.shop_product_repository_skus,
          shop_product_repository_groups: this.wForm.shop_product_repository_groups,
          categoryIds: categoryIds.join(','),
          brandKeyValues
        }
        this.sLoading = true
        this.updateBlindBox({
          data: params,
          success: (res) => {
            this.sLoading = false
            if (res.code === 200) {
              this.editShow = false
              this.$message.success('保存成功')
              this.getTableData(this.pageData.page)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      } catch (e) {
        this.$message.error(e)
        this.sLoading = false
      }
    },
    closeEdit() {
      this.editShow = false
      this.selCateSub = []
      this.selCateSubOptions = []
      this.brandObjCache = {}
      this.sLoading = false
    }
  }
}
</script>

<style scoped>
.w120{
  width: 120px;
}

.gx-bb__notice {
  display: flex;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  margin-bottom: 16px;
  background: rgba(251, 146, 60, 0.07);
  border: 1px solid rgba(251, 146, 60, 0.3);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(102, 102, 102);
  line-height: 1.7;
}
.gx-bb__plat-tabs {
  display: flex;
  border-bottom: 1px solid rgb(224, 224, 236);
  margin-bottom: 14px;
}
.gx-bb__plat-tab {
  padding: 9px 22px;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  background: rgb(255, 255, 255);
  color: rgb(102, 102, 102);
  font-weight: 400;
  transition: 0.15s;
}
.gx-bb__plat-tab--on {
  border-color: currentcolor currentcolor rgb(200, 68, 60);
  color: rgb(200, 68, 60);
  font-weight: 600;
}

.gx-bb__filter {
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  padding: 14px 16px;
  margin-bottom: 14px;
  box-shadow: rgba(0, 0, 0, 0.05) 0 1px 4px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gx-bb__filter-tip{
  padding-top: 8px;
  border-top: 1px dashed rgb(236, 236, 236);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(153, 153, 153);
  line-height: 1.75;
}

.gx-bb__spacer {
  flex: 1;
}
.gx-bb__btn {
  height: 30px;
  padding: 0px 22px;
  border-radius: 4px;
  cursor: pointer;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(224, 224, 236);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  color:#666666;
}
.gx-bb__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-bb__btn--primary {
  background: linear-gradient(135deg, #D4A946, #E8B950);
  border: none;
  font-weight: 600;
  color: #F4F6F8;
}
.gx-bb__btn--danger {
  background: rgb(200, 68, 60);
  border: none;
  font-weight: 600;
  color: #FFFFFF;
}
.table-page-wrapper{
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
}
.page-wrap{
  padding: 10px 14px;
  border-top: 1px solid rgb(224, 224, 236);
  background: rgb(245, 240, 232);
}
.gx-bb__table {
  background: #FFFFFF;
  overflow-x: auto;
}
.gx-bb__table table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
}
.gx-bb__table thead tr:nth-child(1){
  font-weight: 600;
}
.gx-bb__table thead tr:nth-child(2){
  font-weight: 500;
  vertical-align: middle;
  letter-spacing: 0.04em;
  line-height: 1.5;
}
.gx-bb__table th {
  padding: 7px 10px;
  text-align: center;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(102, 102, 102);
  border-bottom: 1px solid rgb(224, 224, 236);
  letter-spacing: 0.04em;
  background: rgb(245, 240, 232);
  border-right: 1px solid rgb(224, 224, 236);
}
.gx-bb__table tr th:last-child{
  border-right: none;
}

.gx-bb__table td {
  padding: 12px 10px;
  vertical-align: middle;
  text-align: center;
  border-bottom: 1px solid rgb(245, 245, 245);
  background: rgb(255, 255, 255);
}
.gx-bb__table tbody tr:hover td {
  background: rgb(255,245,245);
}

.gx-bb__table th.bg-red{
  background: rgb(255, 245, 245);
}
.gx-bb__table td.bg-red{
  background: rgb(255, 250, 250) !important;
}
.gx-bb__th-dec{
  font-size: 10px;
  color: rgb(153, 153, 153);
  font-weight: 400;
}

.gx-bb__counts b {
  color: #1A1A2E;
}
.gx-bb__shop {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.gx-bb__shop-icon{
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Noto Serif SC", serif;
  font-size: 12px;
  font-weight: 700;
  color: rgb(255, 255, 255);
  flex-shrink: 0;
}
.gx-bb__shop-name{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: rgb(26, 26, 46);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-bb__shop-id {
    font-family: "JetBrains Mono", monospace;
    font-size: 10px;
    color: rgb(153, 153, 153);
}
.gx-bb__quota{
  display: flex;
  justify-content: center;
  align-items: center;
}
.gx-bb__quota-item{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 12px;
}
.gx-bb__quota-item~.gx-bb__quota-item{
  border-left: 1px solid rgb(236, 236, 236);
}
.gx-bb__td-num{
  font-family: "JetBrains Mono", monospace;
  font-size: 15px;
  font-weight: 700;
  color: rgb(26, 26, 46);
}
.gx-bb__td-label{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  color: rgb(153, 153, 153);
  margin-top: 2px;
}
.gx-bb__rate{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.gx-bb__rate-progress{
  position: relative;
  height: 5px;
  border-radius: 3px;
  background: rgb(235, 235, 235);
  margin-bottom: 1px;
  width: 80%;
  margin-top: 3px;
}
.gx-bb__rate-progress::before{
  content: "";
  position: absolute;
  top: -2px;
  left: 50%;
  width: 1px;
  height: 9px;
  background: rgb(170, 170, 170);
}
.gx-bb__rate-progress-bar{
  height: 100%;
  border-radius: 3px;
}
.gx-bb__rate-progress-bar--red{
  background: var(--gx-red);
}

.gx-bb__rate-progress-bar--green{
  background: var(--gx-green);
}
.gx-bb__rate-progress-half{
  text-align: center;
  font-size: 9px;
  color: rgb(153, 153, 153);
  margin-top: 1px;
  margin-bottom: 2px;
}
.gx-bb__tag {
  padding: 2px 8px;
  border-radius: 3px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
}
.gx-bb__tag--mi{
  padding: 1px 7px;
  font-size: 10px;
}
.gx-bb__tag--danger{
  padding: 2px 8px;
  border-radius: 3px;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  font-size: 11px;
  color: rgb(200, 68, 60);
}
.gx-bb__tag--warn {
  background: rgb(255, 247, 230);
  border: 1px solid rgb(255, 213, 145);
  color: rgb(251, 146, 60);
}
.gx-bb__tag--info {
  background: rgba(139, 157, 195, .1);
  border: 1px solid rgba(139, 157, 195, .3);
  color: #6A6A8A;
}
.gx-bb__tag--success {
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  color: #67c23a;
}
.gx-bb__switch {
  width: 36px;
  height: 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.15);
  position: relative;
  transition: background .2s;
  display: inline-flex;
  align-items: center;
  padding: 0 2px;
  box-sizing: border-box;
}
.gx-bb__switch--on {
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));
  box-shadow: rgba(255, 77, 79, 0.3) 0px 0px 8px;
}
.gx-bb__switch-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #FFFFFF;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .2);
  transition: transform .2s;
}
.gx-bb__switch--on .gx-bb__switch-dot {
  transform: translateX(16px);
}
.gx-bb__ops {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5px;
}
.gx-bb__op {
  height: 24px;
  padding: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 11px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  color: #4A4A6A;
  transition: all .15s;
}
.gx-bb__op:disabled {
  opacity: .5;
  cursor: not-allowed;
}

.gx-bb__op--edit {
  border: none;
  background: transparent;
  color: rgb(200, 68, 60);
}
.gx-bb__op--edit:hover {
 text-decoration: underline;
}
.gx-bb__empty {
  text-align: center;
  padding: 40px 0 !important;
  color: #6A6A8A;
}

/* 弹窗 */
.gx-bb__modal-box--xl {
  max-width: 900px;
}
.gx-modal-head-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.gx-bb__form {
  display: flex;
  flex-direction: column;
}
.gx-bb__form :deep(.el-form-item){
  margin-bottom: 10px;
}
.gx-bb__form :deep(.el-form-item__label){
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: var(--gx-black);
  padding: 0 8px 0 0;
}
.gx-bb__form :deep(.el-input__inner){
  color: var(--gx-black);
}

.gx-bb__tip {
  font-size: 11px;
  color: #6A6A8A;
  line-height: 1.6;
}
.gx-bb__tip--red {
  color: #F87171;
}
.gx-bb__section-title {
  font-size: 14px;
  font-weight: 700;
  color: #1A1A2E;
  margin: 4px 0 12px;
  padding-left: 10px;
  border-left: 3px solid #D4A946;
}

</style>
